import { ProductViewTemplateModel } from '@shared/product/components/product-view/models/product-view-template.model';

interface MediaModelOptional {
    alignBottom?: string;
    classImage?: string;
    clickable?: boolean;
    idMedia?: string;
    imageIndex?: number;
    imagePriority?: boolean;
    showWaterMark?: boolean;
}

export type MediaRatioSkeleton = '2-3' | '3-4' | '1-1' | '4-3' | '3-2' | '16-9' | '2-1' | '9-20' | 'full';

export enum MediaFormatImage {
    WEBP = 'chrome',
    JPG = 'generic',
}

export type MediaPropRatioClass = 'rat-2-3' | 'rat-3-4' | 'rat-1-1' | 'rat-4-3' | 'rat-3-2' | 'rat-16-9' | 'rat-2-1' | 'rat-full';

export const MediaWidthMultiplier: number = 1.2;

export const MaxWidthLargeScreenCDN: number = 2500;

/**
 * Componente de imagen con skeletor de Holygrail2.
 * @Input ratio - Necesario para guardar el espacio necesario en el DOM antes de tener la imagen cargada
 * @Input OPTIONAL showWaterMark - Gestión de marca de agua para imagenes sin licencia
 * @Input OPTIONAL widthVW - "(max-width: 800) 100vw, 50vw" -> ej: 100% en pantallas inferiores a 800 y 50% al resto
 * @Input OPTIONAL pointer - Agrega clase css cursor-pointer
 * @Input OPTIONAL imagePriority - Agrega imagen en la prerenderización de servidor (IMPORTANTE!! solo puede existir una por página)
 *
 */
export interface MediaModel extends MediaModelOptional {
    ratio: MediaRatioSkeleton;
    widthVW?: string;
    alt?: string;
}

export type ProductCardModel = ProductViewTemplateModel;

export interface LoaderParamsModel {
    hasAmandaSrc: boolean;
    imageFormat: MediaFormatImage;
}

export const imageOptimizeConfig = {
    breakpoints: [200, 400, 850, 1024, 1440, 1920, 2400, 4000],
};

export interface CommonWindowMedia {
    innerWidth: number;
    devicePixelRatio: number;
    imageFormat: MediaFormatImage;
    AudioContext: typeof AudioContext;
    webkitAudioContext: typeof AudioContext;
}
